import React, { Component } from 'react'

export default class Input extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: this.props.defaultValue
        }

        this.onBlur = (e) => {
            const value = e.target.value;
            if(value !=  this.props.defaultValue){
                console.log("es distinto")
                this.props.onChange(e);
            }else{
                console.log("es igual")
            }
        }

        this.onChange = (e) => {
            const value = e.target.value;
            this.setState({
                value: value
            });
        }

    }
    render() {
        return (
            <input onBlur={this.onBlur} onChange={this.onChange} type='number' value={this.state.value} style={{
                width: '40px'
            }} />
        )
    }
}



// WEBPACK FOOTER //
// ./frontEnd/api/tarifa/Input.jsx